<template>
<div class="chapter">
<div class="inner_page">
<h2 class="ch-title"><a id="page_vi"><span class="bold">Acknowledgements</span></a></h2><a id="page_vi">
<p class="noindent1"><span class="drop-cap">T</span>his book would not have been possible without a myriad of friends and family, from the brothers who served alongside Bob and me in Vietnam, to those who guided it along the route from a rough idea to a published book.</p>
<p class="indent">I would especially like to thank the family of my co-author, Bob Hillerby, for their continued support of this project after Bob’s untimely death and their confidence in me to complete it after such a tragedy.</p>
<p class="indent">I thank John White, fellow Vietnam veteran, mentor, and literary agent, for his expert input, guidance, and extreme patience with me. It was also John who came up with the book’s title.</p>
<p class="indent">I appreciate all the feedback and encouragement from family and friends: My dear friend and companion Marion Bouffard, and three excellent writers, my daughters Marissa and Melanie, and my dear friend, Gary Carlson. Others who responded so kindly to my constant badgering to review my work as it progressed include my aunt, Lucy Brookes, my sister, Carol Hageman, and my nephew, Coulson Hageman, who also aided me in my quest for the very first images of war photography. A special thank you goes to Alesia LeDuc for her thorough proofreading and corrections.</p>
<p class="indent">Special thanks also go to Bob’s and my fellow veterans, members of the 221st Signal Company and 69th Signal Battalion, who through the magic of today’s social media, were there with feedback and answers to questions about our shared experiences in Vietnam.</p>
<p class="indent">I am also grateful to my senior editor Chris Evans and Pen &amp; Sword Books for believing in this book and bringing it life.</p>
<p class="indent">Finally, I’d like to thank Tony Swindell for sharing his story, for being willing and brave enough to relive the most challenging, difficult and often horrifying moments of his life. Thank you for digging so deep and going there with Bob Hillerby and me.</p>
<p class="right">Dan Brookes</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_acknowledgements.vue?02e7b89e